export const load = () => ({
	h1: 'Meet the Indow Management Team',
	title: 'Meet the Indow Management Team',
	description:
		'Meet the Indow management team. We are creative innovators who use technology to make our living environment more comfortable and efficient. Learn how Indow is encouraging collaboration, prioritizing inclusion, and working for equity.',
	showTitle: true,
});
